import React from 'react';
import { Layout } from './components/Layout';
import { WorkspacesPage } from './components/workspaces/WorkspacesPage';
export function App() {
  return <Layout data-id="element-0">
      <WorkspacesPage data-id="element-1" />
    </Layout>;
}